var a={video:"Play",audio:"Headphones"};export{a as SUPPORTED_ICONS};
//# sourceMappingURL=FGMediaObjectFigure.shared.js.map
